import {useStyles} from "./InputControl.styles";

type Props = {
    value: string
    onChange: (value: string) => void
    type?: "text" | "number"
    className?: string
}

const InputControl = (
    {
        value,
        onChange,
        type = "text",
        className = "",
    }: Props
) => {
    const styles = useStyles();
    return (
        <div className={`${styles.component} ${className}`}>

            <input
                type={type}
                value={value}
                onChange={e => onChange(e.target.value)}
                className={styles.input}
            />
        </div>
    )
}

export default InputControl;